import { ReactComponent as DeleteIcon } from '@/assets/icons/delete-icon.svg';
import { ReactComponent as DotIcon } from '@/assets/icons/dots-v.svg';
import { Col, Row, Select } from 'antd';
import { useCallback } from 'react';
import IconButton from '../../Buttons/IconButton';
import SvgConverter from '../../Common/SvgConverter';

const ColumnCard = ({
  dragHandleListeners = {},
  availableColumns = [],
  isColumnsLoading = false,
  handleRemoveColumn = () => {},
  index,
  handleSelectValueChange,
  selectedValue,
}) => {
  const onChange = useCallback(
    (_value, option) => {
      handleSelectValueChange(option, index);
    },
    [index, handleSelectValueChange],
  );
  return (
    <div className="shipment-column-options-card-dnd">
      <div className="shipment-column-container">
        <Row gutter={10} align="middle">
          <Col>
            <Row gutter={2} {...dragHandleListeners} style={{ cursor: 'grab' }}>
              <Col>
                <SvgConverter Icon={DotIcon} color="header" className="d-flex" height={15} />
              </Col>
              <Col>
                <SvgConverter Icon={DotIcon} color="header" className="d-flex" height={15} />
              </Col>
              <Col>
                <SvgConverter Icon={DotIcon} color="header" className="d-flex" height={15} />
              </Col>
            </Row>
          </Col>
          <Col className="flex-1">
            <Select
              style={{ width: '100%' }}
              placeholder="Select a column"
              onChange={onChange}
              options={availableColumns}
              defaultValue={selectedValue?.columnValue || selectedValue?.value}
              loading={isColumnsLoading}
            />
          </Col>
          <Col>
            <Row className="flex-direction-column" justify="center">
              <IconButton onClick={() => handleRemoveColumn(index)}>
                <SvgConverter Icon={DeleteIcon} color="danger" className="d-flex" height={20} width={20} />
              </IconButton>
            </Row>
          </Col>
        </Row>
      </div>
    </div>
  );
};

export default ColumnCard;
